import { key, keyCodes } from './helpers';

jQuery(function ($) {
  $('.blazy--photoswipe.blazy--field-images').each(function () {
    const $slider = $(this);

    let isDown = false;
    let ignoreClick = false;
    let startX;
    let scrollLeft;
    let disableAutoscroll = false;
    let autoscrollWalk = 0;
    let autoScrollActive = false;
    const fpsInterval = 1000 / 60; // 60 fps
    let lastStamp = null;
    let elapsed;
    let isShiftPressed = false;

    const stopDragging = function () {
      isDown = false;
      setTimeout(() => {
        ignoreClick = false;
      });
      $slider.removeClass('active');
    };

    const stopAutoscroll = function () {
      $slider.removeClass('autoscroll-left autoscroll-right');
      autoScrollActive = false;
      lastStamp = null;
    };

    const updateAutoscroll = function () {
      // eslint-disable-next-line operator-assignment
      $slider[0].scrollLeft = $slider[0].scrollLeft + autoscrollWalk;
    };

    $slider.on('mousedown', (e) => {
      isDown = true;
      $slider.addClass('active');
      startX = e.pageX - $slider.offset().left;
      scrollLeft = $slider.scrollLeft();

      disableAutoscroll = true;
      stopAutoscroll();
    });
    $slider.on('mouseleave', function () {
      stopDragging();

      disableAutoscroll = false;
      stopAutoscroll();
    });
    $slider.on('mouseup', stopDragging);
    $slider.on('mousemove', (e) => {
      const x = e.pageX - $slider.offset().left;
      if (!isDown) {
        if (disableAutoscroll) {
          return;
        }

        const percent = x / $slider.width();
        // Magnitude ranges from .25 to .75
        const magnitude = 0.25 + Math.abs(0.5 - percent);
        // Walk ranges from 1.75 to 5.25
        let walk = 7 * magnitude;
        // Then we square it (~3 to ~27) which grows exponentially as the cursor is closer to the
        // edge of the screen.
        walk *= walk;

        const deadZoneStart = $slider.width() / 2 - 75;
        const deadZoneEnd = $slider.width() / 2 + 75;

        if (x >= deadZoneStart && x <= deadZoneEnd) {
          stopAutoscroll();

          return;
        }

        if (percent < 0.5) {
          // Scroll left
          autoscrollWalk = -walk;
          if (!$slider.hasClass('autoscroll-left')) {
            $slider.removeClass('autoscroll-right');
            $slider.addClass('autoscroll-left');
          }
        } else {
          // Scroll right
          autoscrollWalk = walk;
          if (!$slider.hasClass('autoscroll-right')) {
            $slider.removeClass('autoscroll-left');
            $slider.addClass('autoscroll-right');
          }
        }

        if (!autoScrollActive) {
          autoScrollActive = true;

          const scrollFunc = (now) => {
            if (!autoScrollActive) {
              return;
            }
            requestAnimationFrame(scrollFunc);

            if (!lastStamp) {
              lastStamp = now;
              updateAutoscroll();
            } else {
              elapsed = now - lastStamp;

              // Gate animation at 60fps
              // credit: https://stackoverflow.com/a/19772220
              if (elapsed > fpsInterval) {
                lastStamp = now - (elapsed % fpsInterval);
                updateAutoscroll();
              }
            }
          };
          requestAnimationFrame(scrollFunc);
        }
      } else {
        $slider.removeClass('autoscroll-left autoscroll-right');
        ignoreClick = true;
        e.preventDefault();
        const walk = (x - startX) * 1.7; // scroll-speed
        $slider.scrollLeft(scrollLeft - walk);
      }
    });

    $(window).on('keydown', function (e) {
      if (key(e) === keyCodes.shift) {
        isShiftPressed = true;
      }
    });
    $(window).on('keyup', function (e) {
      if (key(e) === keyCodes.shift) {
        isShiftPressed = false;
      }
    });

    $slider.on('wheel', function () {
      if (isShiftPressed) {
        disableAutoscroll = true;
        stopAutoscroll();
      }
    });

    $('a.litebox', $slider).each(function () {
      this.addEventListener(
        'click',
        function (e) {
          if (ignoreClick) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        },
        true,
      );
    });

    // Center gallery scrollable content
    $slider.scrollLeft(90);

    const checkScrollWidth = () => {
      const scrollableWidth = $slider[0].scrollWidth - $slider[0].clientWidth;
      if (!scrollableWidth) {
        $slider.removeClass('scrollable');
      } else {
        $slider.addClass('scrollable');
      }
    };

    // Recalculate scroll width on resize
    new ResizeObserver(checkScrollWidth).observe($slider[0]);
    $(window).on('resize', checkScrollWidth);
    checkScrollWidth();
  });
});
